import { RemoteValidateCellphone } from "../../../../data/usecases/cellphone/remote-validate-cellphone";
import { ValidateCellphone } from "../../../../domain/usecases/validate-cellphone";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteValidateCellphone = (): ValidateCellphone =>
  new RemoteValidateCellphone(
    makeApiUrl("/cellphones/validate-cellphone"),
    makeAxiosHttpClient()
  );
